var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('device-config-comp',{on:{"save":_vm.enterDeviceConfig,"cancel":_vm.enterDeviceConfig}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }